/**
 * デュエル一覧の試合の行の「撮影予定に追加」（Issue #692）。撮り方は前の試合と同じ（「撮影」の「撮影予定」タブで変える）。
 * 撮影予定に入れる試合は撮り直しなので、その試合の入力の記録（再現エンジンの replay）を消してまっさらな開始前にする（Issue #747）。
 * 応答が記録されていれば確かめてから。応答の無い replay は黙って消す。旧エンジンの操作ログは消さない。
 */
import { useState } from 'react';
import { api } from '../api/api';
import { addItem, toItems } from '../utils/liveMatch';

export default function AddToScheduleButton({ gameUuid }) {
  const [msg, setMsg] = useState(null);
  const add = async () => {
    try {
      const m = await api.project('GetLiveMatch', {});
      const items = toItems(m.schedule);
      const next = addItem(items, gameUuid);
      if (next === items) { setMsg('もう入っています'); return; }
      const res = await api.ocgListReplays(gameUuid);
      const replays = Array.isArray(res) ? res : (res?.data ?? []);
      const ops = replays.reduce((n, r) => n + (r.op_count || 0), 0);
      if (ops > 0 && !window.confirm(`この試合の入力の記録（応答 ${ops} 件）を消して撮影予定に入れます。消した記録は戻せません。よろしいですか？`)) return;
      for (const r of replays) await api.ocgDeleteReplay(r.replay_id);
      await api.project('SetLiveSchedule', { items: next });
      setMsg(`撮影予定の ${next.length} 番目に入れました${replays.length ? '（入力の記録を消しました）' : ''}`);
    } catch (e) {
      setMsg(String(e?.message ?? e));
    }
  };
  return (
    <span style={{ display: 'inline-flex', gap: 4, alignItems: 'center' }}>
      <button type="button" className="btn btn-sm btn-secondary" data-testid="add-to-schedule" onClick={add}
        title="撮影予定の列の最後に入れる（撮影の流れ。Issue #692）。その試合の入力の記録は消す（Issue #747）">撮影予定に追加</button>
      {msg ? <span role="status" style={{ fontSize: '0.75rem', color: '#7c7' }}>{msg}</span> : null}
    </span>
  );
}
